export default __webpack_public_path__ + "static/media/6ddfd243e2ba708e8e40f54d0d823afd.b0128ee2.png";